import { Box, Typography } from '@mui/material'

export const ThanksForRegisteringPage = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<img
				src={'/images/ontimebridelogo.svg'}
				alt="logo"
				loading="lazy"
				style={{
					width: 'clamp(20em, 70vw, 50em)',
				}}
			/>
			<Typography
				variant="h3"
				sx={{
					marginTop: '2em',
					textAlign: 'center',
				}}
			>
				Thank you for pre-registering with On Time Bride!
			</Typography>
		</Box>
	)
}
